import Header from "./Header";
import HeaderTheme, { headerHeight } from "./theme";
// Do not expose helper functions if they are not needed outside of the component
export { Header, HeaderTheme, headerHeight };
//# sourceMappingURL=index.js.map